import { Button } from '@/components/ui/button';
import { FileArchive, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { useState } from 'react';
import { supabase } from '@/integrations/supabase/client';

interface LiquidityBatchExportProps {
  periodDays?: number;
}

export default function LiquidityBatchExport({ periodDays = 30 }: LiquidityBatchExportProps) {
  const [loading, setLoading] = useState(false);

  async function generateBatchZip() {
    setLoading(true);
    toast('Generating batch export for all companies...');

    try {
      const { data, error } = await supabase.functions.invoke('generate-liquidity-batch-zip', {
        body: { periodDays },
      });

      if (error) throw error;

      const { url, companyCount } = data;
      toast.success(`ZIP generated successfully with ${companyCount} company reports`);

      // Download the ZIP file
      if (url) {
        window.open(url, '_blank');
      }
    } catch (error: any) {
      console.error('Error generating batch ZIP:', error);
      toast.error(error.message || 'Failed to generate batch ZIP');
    } finally {
      setLoading(false);
    }
  }

  return (
    <Button onClick={generateBatchZip} disabled={loading} variant="outline">
      {loading ? (
        <Loader2 className="h-4 w-4 mr-2 animate-spin" />
      ) : (
        <FileArchive className="h-4 w-4 mr-2" />
      )}
      Export All Companies (ZIP)
    </Button>
  );
}
